const DEFAULT_APP_NAME = "Goalzin";
const DEFAULT_LOGO_PATH = "assets/logo/logo-new.png";

type BrandingConfig = {
  name?: string;
  logo?: string;
  favicon?: string;
};

declare global {
  interface Window {
    __APP_BRANDING__?: BrandingConfig;
  }
}

const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/+$/, "");

const normalizeRelativePath = (path: string) => path.replace(/^\/+/, "");

const getRuntimeBranding = (): BrandingConfig => {
  if (typeof window === "undefined") {
    return {};
  }
  return window.__APP_BRANDING__ || {};
};

const runtimeBranding = getRuntimeBranding();

const configuredName =
  runtimeBranding.name || process.env.REACT_APP_APPLICATION_NAME;

const configuredLogo =
  runtimeBranding.logo || process.env.REACT_APP_APPLICATION_LOGO;

// Falls back to the sidebar logo when unset, matching the inline bootstrap
// script in public/index.html so both stay in sync.
const configuredFavicon =
  runtimeBranding.favicon || process.env.REACT_APP_APPLICATION_FAVICON || configuredLogo;

const resolvePath = (path: string) => {
  if (path && /^https?:\/\//i.test(path)) {
    return path;
  }
  const relativePath = normalizeRelativePath(path);
  return publicUrl ? `${publicUrl}/${relativePath}` : `/${relativePath}`;
};

export const APP_NAME = (configuredName || DEFAULT_APP_NAME).trim();

export const APP_LOGO = resolvePath(configuredLogo || DEFAULT_LOGO_PATH);

export const APP_FAVICON = resolvePath(configuredFavicon || DEFAULT_LOGO_PATH);
